import { Component, Vue } from 'vue-property-decorator';
import { DisplayEnum } from '@/types/enum';
import { FilterDataType, AllFilterDateMapping } from '@/types/product';
import { convertProductUri, toI18n } from '@/utils/commonUtils';
import { changeDateFormat } from '@/utils/dateUtils';
import { GridProps } from '@/types/board';
import { RadioRenderer, escapeHtml, centerWinOptions } from '@/utils/commonUtils';

@Component
export default class ProductInquiryDataMixin extends Vue {
  public today: string = changeDateFormat('', 'YYYY-MM-DD');
  public delayCount = 0;
  public tableTitle = '';

  public get delayed(): boolean {
    const delayed = this.$route.query.delayYn;
    if (delayed && delayed === 'Y') {
      return true;
    }
    return false;
  }

  public orderInfoData = {};
  public repliedData = {};

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.toI18n(needToI18nStr));
  }

  //last version api:
  // public searchParams = {
  //   mallNo: '0',
  //   searchDateType: 'REGISTER_YMDT',
  //   searchType: 'ALL',
  //   endYmdt: '',
  //   startYmdt: '',
  //   page: 1,
  //   size: 30,
  //   replied: '',
  //   keyword: '',
  //   delayed: false
  // };

  public searchParams = {
    mallNo: '0',
    searchDateType: 'REGISTER_YMDT',
    searchType: 'ALL',
    startYmd: '',
    endYmd: '',
    page: 1,
    size: 30,
    replyStatusType:
      this.$route.query.replyYn == null || this.$route.query.replyYn == undefined || this.$route.query.replyYn == ''
        ? 'ALL'
        : this.$route.query.replyYn == 'N'
        ? 'READY'
        : 'COMPLETE',
    keyword: '',
  };

  public searchParamsClone = { ...this.searchParams };

  public searchDateType: DisplayEnum[] = [
    { value: 'REGISTER_YMDT', label: this.toI18n('PRODUCT_INQUIRY_REGISTRATION_DATE') },
    { value: 'REPLY_YMDT', label: this.toI18n('PRODUCT_INQUIRY_REPLY_DATE') },
  ];

  public replied = [
    { value: 'ALL', label: this.toI18n('PRODUCT_INQUIRY_ALL') },
    { value: 'READY', label: this.toI18n('PRODUCT_INQUIRY_WAITING_FOR_REPLY') },
    { value: 'COMPLETE', label: this.toI18n('PRODUCT_INQUIRY_ANSWER_COMPLETED') },
  ];

  public searchType: DisplayEnum[] = [
    { value: 'ALL', label: '선택' },
    { value: 'MALL_PRODUCT_NO', label: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NUMBER') },
    { value: 'PARTNER_NAME', label: this.toI18n('PRODUCT_INQUIRY_PARTNER') },
    { value: 'MEMBER_ID', label: this.toI18n('PRODUCT_INQUIRY_WRITER') },
    { value: 'ADMIN_NAME', label: this.toI18n('PRODUCT_INQUIRY_MANAGER') },
  ];

  public filterDateData: FilterDataType[] = [
    { value: '0', label: this.toI18n('BOARD_FAQ_TODAY'), selected: false }, // 오늘
    { value: '1w', label: this.toI18n('BOARD_FAQ_1WEEK'), selected: false }, // 1주일
    { value: '1m', label: this.toI18n('BOARD_FAQ_1MONTH'), selected: true }, // 1개월
    { value: '3m', label: this.toI18n('BOARD_FAQ_3MONTHS'), selected: false }, // 3개월
    { value: '6m', label: this.toI18n('BOARD_FAQ_6MONTHS'), selected: false }, // 6개월
    { value: '1y', label: this.toI18n('BOARD_FAQ_1YEAR'), selected: false }, // 1년
  ];

  public filterDateMapping: AllFilterDateMapping = {
    '0': [0, 'd'],
    '1w': [-7, 'd'],
    '1m': [-1, 'M'],
    '3m': [-3, 'M'],
    '6m': [-6, 'M'],
    '1y': [-1, 'y'],
    ALL: [100, ''],
  };

  public inquiryType: { [propName: string]: any } = {
    PRODUCT: this.toI18n('PRODUCT_INQUIRY_PRODUCT'),
    DELIVERY: this.toI18n('PRODUCT_INQUIRY_DELIVERY'),
    CANCEL: this.toI18n('PRODUCT_INQUIRY_CANCEL'),
    RETURN: this.toI18n('PRODUCT_INQUIRY_RETURN'),
    EXCHANGE: this.toI18n('PRODUCT_INQUIRY_EXCHANGE'),
    REFUND: this.toI18n('PRODUCT_INQUIRY_REFUND'),
    OTHER: this.toI18n('PRODUCT_INQUIRY_ETC'),
  };

  public searchRespones = {
    contents: [],
    totalPage: 0,
    totalCount: 0,
  };

  public productDetailUrlObj: { [propName: string]: string }[] = [];
  public getProductDetailUrl({ value, row }: any): string {
    const detail = this.productDetailUrlObj.find((item: any): boolean => Object.keys(item) + '' === row.mallNo + '');
    const href = convertProductUri(detail[row.mallNo + ''], value);
    const url = `<a target="_blank" href="${href}">${value}</a>`;
    return url;
  }

  public gridOptions?: { [propName: string]: any } = {
    rowHeaders: [
      {
        name: 'radioBtn',
        type: 'radio',
        header: this.toI18n('ADMIN_LIST_SELECT'), // 선택
        renderer: RadioRenderer,
      },
    ],
    header: {
      height: 33,
    },
    rowHeight: 39,
    displayRowCount: 8,
    isInitialRequest: true,
    useClientSort: false,
    bodyHeight: 480,
    minRowHeight: 39,
    heightResizable: true,
    copyOptions: {
      useFormattedValue: true,
    },
  };

  public newColumnsCustomization: { [propName: string]: any } = [];
  public gridProps: GridProps = {
    columns: [
      {
        header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_STATUS'),
        name: 'replied',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value
            ? this.toI18n('PRODUCT_INQUIRY_ANSWER_COMPLETED')
            : this.toI18n('PRODUCT_INQUIRY_WAITING_FOR_REPLY');
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_SHOPPING_MALL'),
        name: 'mallNo',
        align: 'center',
        minWidth: 80,
        formatter: ({ row }: any): string => {
          return row.mall.mallName;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NUMBER'),
        name: 'mallProductNo',
        align: 'center',
        minWidth: 80,
        formatter: this.getProductDetailUrl,
        copyOptions: {
          customValue: (value): string => {
            return value;
          },
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NAME'),
        name: 'productName',
        align: 'left',
        minWidth: 200,
        formatter: ({ value }: any): string => {
          return `<div class="ellipsis">${escapeHtml(value)}</div>`;
        },
        copyOptions: {
          customValue: (value): string => {
            return value;
          },
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_TYPE'),
        name: 'inquiryType',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          return this.inquiryType[value];
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_SECRET'),
        name: 'isSecret',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value ? this.toI18n('PRODUCT_INQUIRY_SECRET') : this.toI18n('PRODUCT_INQUIRY_NORMAL');
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_TITLE'),
        name: 'title',
        align: 'left',
        minWidth: 280,
        formatter: ({ value, row }: any): string => {
          return `<div class="break-all">${
            value && value.toString().trim().length > 0 ? value : '-'
          }</div><input type="hidden" class="inquiryTitle" value="${row.title}" />`;
        },
        copyOptions: {
          customValue: (value): string => value,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRIES'),
        name: 'content',
        align: 'left',
        minWidth: 280,
        formatter: ({ value, row }: any): string => {
          return `<div class="break-all">${value}</div><input type="hidden" class="inquiryNo" value="${row.inquiryNo}" />`;
        },
        copyOptions: {
          customValue: (value): string => {
            return value;
          },
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PURCHASE_OR_NOT'),
        name: 'orderNo',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value ? this.toI18n('PRODUCT_INQUIRY_PURCHASE') : this.toI18n('PRODUCT_INQUIRY_DO_NOT_PURCHASE');
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PARTNER'),
        name: 'partner',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value?.partnerName;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_WRITER'),
        name: 'member',
        align: 'center',
        minWidth: 150,
        formatter: ({ value, row: { registerNo } }: any): string => {
          if (!value) {
            return this.toI18n('PRODUCT_INQUIRY_WRONG_USER');
          }

          if (value.memberStatus === 'EXPELLED') {
            return this.toI18n('PRODUCT_INQUIRY_WITHDRAWAL_MEMBER');
          }
          //??? memberId, memberIdView need !!!!!!
          const memberName = `${value.memberId} (${registerNo})`;
          const url = `/member/popup/crm/${registerNo}`;
          return `<a href="javascript:onclick=window.open('${url}','memberPopupCrm','${centerWinOptions(
            1060,
            800,
          )}')">${memberName}</a>`;
        },
        copyOptions: {
          customValue: (value): string => {
            return value.memberId;
          },
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_DATE'),
        name: 'registerDateTime',
        align: 'center',
        minWidth: 140,
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_DATE_AND_TIME'),
        name: 'repliedDateTime',
        align: 'center',
        minWidth: 140,
        copyOptions: {
          useFormattedValue: true,
        },
      },
    ],
    pageOptions: {
      page: 1,
      totalCount: 0,
      perPage: 30,
    },
  };

  public gridPropsExcel: GridProps = {
    columns: [
      {
        header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_STATUS'),
        name: 'replied',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value
            ? this.toI18n('PRODUCT_INQUIRY_ANSWER_COMPLETED')
            : this.toI18n('PRODUCT_INQUIRY_WAITING_FOR_REPLY');
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_SHOPPING_MALL'),
        name: 'mallNo',
        align: 'center',
        minWidth: 80,
        formatter: ({ row }: any): string => {
          return `<span>${row.mall.mallName}</span>`;
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NUMBER'),
        name: 'mallProductNo',
        align: 'center',
        minWidth: 80,
        formatter: this.getProductDetailUrl,
        copyOptions: {
          useFormattedValue: false,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NAME'),
        name: 'productName',
        align: 'left',
        minWidth: 200,
        formatter: ({ value }: any): string => {
          return `<div class="ellipsis">${escapeHtml(value)}</div>`;
        },
        copyOptions: {
          useFormattedValue: false,
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_TYPE'),
        name: 'inquiryType',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          return this.inquiryType[value];
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_SECRET'),
        name: 'isSecret',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value ? this.toI18n('PRODUCT_INQUIRY_SECRET') : this.toI18n('PRODUCT_INQUIRY_NORMAL');
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRIES'),
        name: 'content',
        align: 'left',
        minWidth: 280,
        formatter: ({ value, row }: any): string => {
          return `<div class="tui-grid-cell-content" style="white-space:nowrap;max-height:31px"><div class="break-all">${value}</div><input type="hidden" class="inquiryNo" value="${row.inquiryNo}" /></div>`;
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_PURCHASE_OR_NOT'),
        name: 'orderNo1',
        align: 'center',
        minWidth: 75,
        formatter: ({ row }: any): string => {
          return row.orderNo ? this.toI18n('PRODUCT_INQUIRY_PURCHASE') : this.toI18n('PRODUCT_INQUIRY_DO_NOT_PURCHASE');
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_ORDERINFOR_TABLE_TXT2'),
        name: 'orderNo',
        align: 'center',
        minWidth: 75,
      },

      {
        header: this.toI18n('PRODUCT_INQUIRY_PARTNER'),
        name: 'partner',
        align: 'center',
        minWidth: 75,
        formatter: ({ value }: any): string => {
          return value?.partnerName; //그리드 엑셀
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_WRITER'),
        name: 'member',
        align: 'center',
        minWidth: 150,
        formatter: ({ value, row: { registerNo } }: any): string => {
          if (!value) {
            return this.toI18n('PRODUCT_INQUIRY_WRONG_USER');
          }

          if (value.memberStatus === 'EXPELLED') {
            return this.toI18n('PRODUCT_INQUIRY_WITHDRAWAL_MEMBER');
          }
          //??? memberId, memberIdView need !!!!!!
          const memberName = `${value.memberId} (${registerNo})`;
          const url = `/member/popup/crm/${registerNo}`;
          return `<a href="javascript:onclick=window.open('${url}','memberPopupCrm','${centerWinOptions(
            1060,
            800,
          )}')">${memberName}</a>`;
        },
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_DATE'),
        name: 'registerDateTime',
        align: 'center',
        minWidth: 140,
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_DATE_AND_TIME'),
        name: 'repliedDateTime',
        align: 'center',
        minWidth: 140,
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_ANSWER_AUTHOR'),
        name: 'replyRegisterName',
        align: 'center',
        minWidth: 140,
      },
      {
        header: this.toI18n('PRODUCT_INQUIRY_ANSWER_CONTENTS'),
        name: 'replyContent',
        align: 'center',
        minWidth: 140,
      },
    ],
    pageOptions: {
      page: 1,
      totalCount: 0,
      perPage: 30,
    },
  };

  public excelColumns = [
    { header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_STATUS'), name: 'replied' },
    { header: this.toI18n('PRODUCT_INQUIRY_SHOPPING_MALL'), name: 'mallNo' },
    { header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NUMBER'), name: 'mallProductNo' },
    { header: this.toI18n('PRODUCT_INQUIRY_PRODUCT_NAME'), name: 'productName' },
    { header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_TYPE'), name: 'productInquiryTypeLabel' },
    { header: this.toI18n('PRODUCT_INQUIRY_SECRET'), name: 'isSecret' },
    { header: this.toI18n('PRODUCT_INQUIRY_INQUIRIES'), name: 'content' },
    { header: this.toI18n('PRODUCT_INQUIRY_PURCHASE_OR_NOT'), name: 'orderNo' },
    { header: this.toI18n('PRODUCT_INQUIRY_PARTNER'), name: 'partnerName' },
    { header: this.toI18n('PRODUCT_INQUIRY_WRITER'), name: 'registerName' },
    { header: this.toI18n('PRODUCT_INQUIRY_INQUIRY_DATE'), name: 'registerDateTime' },
    { header: this.toI18n('PRODUCT_INQUIRY_RESPONSE_DATE_AND_TIME'), name: 'repliedDateTime' },
  ];
}
